var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    staticClass: "servicos-filter",
    attrs: {
      "fields": _vm.filterFields
    }
  }), _c('TableApp', {
    ref: "servicolist",
    staticClass: "servicos-table",
    attrs: {
      "titulo": "Serviços",
      "acaoBtn": "/#/servicos-novo",
      "textoBtn": "Novo serviço",
      "api-url": "/servicos",
      "fields": _vm.fields,
      "classFilterColumn": "discriminacao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'discriminacao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "discriminacao"
          },
          slot: "discriminacao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.discriminacao) + " ")])])]) : _vm._e(), props.field == 'valor' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar servico',
            expression: "'Editar servico'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleEditServico(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Excluir servico',
            expression: "'Excluir servico'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteServico(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };